import React, { useCallback, useEffect, useRef, useState } from 'react';

import Grid from '@mui/material/Grid2';

// import { makeStyles } from '../../../../../utilities/theme_utilities';

import { 
  Character, 
  // CharacterFeatureSource, 
  CharacterSheetInterface,
} from "@dndModels";

import CharacterAC from "@dndComponents/character/misc/CharacterAC";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface Props {
  char: Character;
}

export default function CharacterACButton({
  char,
}: Props) {
  const [open, setOpen] = useState(false);
  const [ac, setAC] = useState(0);
  const mounted = useRef(false);

  const char_int = char.char_interface;

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback(() => {
    console.log("Char AC - Recalculated");
    console.log(char.armor_class);
    console.log(char_int.armor_class);
    setTimeout(() => setAC(char_int.armor_class), 100);
  }, [char_int]);

  useEffect(() => {
    char.subscription_holder.subscribe("Recalculated", mounted, recalculated);
    recalculated();
  }, [recalculated]);
  
  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
          char.subscription_holder.modalClosed();
        }}>
        { open &&
          <CharacterAC 
            char_int={char_int}
            char={char}
            disabled={false}
            // onChange={onChange}
            // onSourceChange={onSourceChange}
          />
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <Grid container spacing={0} direction="column" className="clickable"
        onClick={() => {
          setOpen(true);
        }}>
        <Grid>
          <div className="centered" style={{
            fontSize: "11px",
            fontWeight: "bold",
          }}>
            Armor
          </div>
        </Grid>
        <Grid>
          <div className="centered" style={{
            fontSize: "24px",
            fontWeight: "bold",
          }}>
            { ac }
          </div>
        </Grid>
        <Grid>
          <div className="centered" style={{
            fontSize: "11px",
            fontWeight: "bold",
          }}>
            Class
          </div>
        </Grid>
      </Grid>
      { renderExtras() }
    </>
  ); 
}

